import { API_URL } from './constants'
import { ApiError } from './client'

export const exportApi = {
    saveOnServer: (groupId) =>
        fetch(`${API_URL}/export/save/${encodeURIComponent(groupId)}`, {
            method: 'POST',
            credentials: 'include',
            headers: { accept: 'application/json' },
        }).then(async (response) => {
            if (!response.ok) {
                const err = await response.json().catch(() => null)
                throw new ApiError(err?.detail || 'Ошибка сохранения экспорта', response.status)
            }
            return response.json().catch(() => null)
        }),

    downloadSchedule: async (groupId) => {
        const response = await fetch(
            `${API_URL}/schedule/export/${encodeURIComponent(groupId)}`,
            {
                method: 'GET',
                credentials: 'include',
            }
        )

        if (!response.ok) {
            throw new ApiError('Ошибка экспорта расписания', response.status)
        }

        const blob = await response.blob()
        const contentDisposition = response.headers.get('content-disposition')
        let fileName = `${groupId}.xlsx`

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/)
            if (match?.[1]) {
                fileName = match[1]
            }
        }

        return { blob, fileName }
    },
}
